import React from 'react';
import UserTypeahead from './UserTypeahead';
import { userNameFormatter } from '../../lib/helper/formatting';

class InternalUserTypeahead extends React.Component {
  render() {
    const {
      label = 'Mediaccounts User',
      name = 'internalUser',
      labelKey = (option) => userNameFormatter(option, false, true),
      rolesToShow = '["ROLE_ADMIN","ROLE_SENIOR_STAFF","ROLE_STAFF","ROLE_OUTSOURCER"]',
      selectedUsers,
      ...rest
    } = this.props;
    // N.B the below filter.roles value is correct - it needs to be a string of an array...
    return <UserTypeahead label={label} labelKey={labelKey} name={name} defaultFilters={{ roles: rolesToShow }} selectedUsers={selectedUsers} {...rest} />;
  }
}

export default InternalUserTypeahead;
